import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Space,
  Text,
} from '@tonic-one/react';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { GlobalApi } from '@Apis';
import { useAccountStore } from '../../../../../models/useAccountModel';

export enum UsableRange {
  User = 0,
  Org = 1,
  Group = 2,
  Site = 3,
}

interface Props {
  onModalClose: (needRefresh: boolean) => void;
  mailbox: string;
}

const DeleteModal = ({ mailbox, onModalClose }: Props) => {
  const { t } = useTranslation();
  const { groupCompanyGuid } = useAccountStore();
  const onDelete = async () => {
    try {
      await GlobalApi.deleteNotificationMailboxes({
        companyGuid: groupCompanyGuid,
        usableRange: UsableRange.Group,
        mailboxes: [mailbox],
      });
      window.showNotification({
        severity: 'success',
        titleMsg: t(
          'globalSetting:globalSetting.sendingMailboxes.deleteSuccessfully'
        ),
      });
      onModalClose(true);
    } catch {
      window.showNotification({
        severity: 'error',
        titleMsg: t('common:common.unknownError'),
      });
      onModalClose(false);
    }
  };
  return (
    <Modal
      closeOnEsc
      closeOnOutsideClick
      isClosable
      isOpen={true}
      onClose={() => {
        onModalClose(false);
      }}
      size="sm"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader></ModalHeader>
        <ModalBody>
          <Text>
            {t(
              'globalSetting:globalSetting.sendingMailboxes.modal.delete.desc'
            )}
          </Text>
          <Space height="20px" />
          <Text>{mailbox}</Text>
        </ModalBody>
        <ModalFooter>
          <Button variant="primary" onClick={onDelete}>
            {t('common:common.action.label.delete')}
          </Button>
          <Space width="2x" />
          <Button
            minWidth="20x"
            onClick={() => {
              onModalClose(false);
            }}
          >
            {t('common:common.button.cancel')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default memo(DeleteModal);
